import * as actionTypes from "../Actions/actionTypes";

const initialState = {
  coderStatus: "bad",
  currentStep: 0,
  shouldOpenPdfModal: false,
  shouldOpenClearModal: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CURRENT_STEP:
      return { ...state, currentStep: action.value };
    case actionTypes.SET_CODER_STATUS:
      return { ...state, coderStatus: action.value };
    case actionTypes.SET_SHOULD_SHOW_PDF_MODAL:
      return { ...state, shouldOpenPdfModal: action.value };
    case actionTypes.SET_SHOULD_SHOW_CLEAR_MODAL:
      return { ...state, shouldOpenClearModal: action.value };
    default:
      return state;
  }
};

export default reducer;
